<div class="dataset-home">
  <app-sub-header
    [badgeText]="'Healthcare Datasets'"
    [title]="'Datasets'"
    [description]="'Explore a comprehensive collection of datasets designed to unlock actionable insights, enable data-driven decision-making, and support scalable, secure innovation across domains.'"
    [iconSrc]="'/icons/sparkle.svg'"
  ></app-sub-header>

  <div
    class="dataset-home__shell flex flex-col gap-6 w-full min-w-0 max-w-full box-border lg:flex-row lg:items-start lg:gap-8"
  >
    <aside class="dataset-home__sidebar w-full shrink-0 min-w-0 lg:w-auto lg:flex-none">
      <app-asset-filter
        [config]="filterConfig"
        [isLoggedIn]="isLoggedIn"
        (filterChange)="onFilterChange($event)"
        (resetFilters)="onResetFilters()"
      ></app-asset-filter>
    </aside>

    <main class="dataset-home__main flex-1 min-w-0 w-full max-w-full flex flex-col gap-4">
      <app-asset-navbar
        [searchPlaceholder]="searchPlaceholderDynamic"
        [searchQuery]="searchQuery"
        [totalCount]="effectiveTotalCount"
        [showingFrom]="showingFrom"
        [showingTo]="showingTo"
        [sortOption]="sortOption"
        [viewMode]="viewMode"
        [isLoggedIn]="isLoggedIn"
        [bookmarksActive]="bookmarksActive"
        [likeActive]="likeActive"
        (searchChange)="onSearchChange($event)"
        (sortChange)="onSortChange($event)"
        (viewModeChange)="onViewModeChange($event)"
        (bookmarksClick)="onBookmarksNavbarClick()"
        (likesClick)="onLikesNavbarClick()"
      ></app-asset-navbar>

      @if (isLoading()) {
        <div
          class="dataset-home__grid grid gap-4 min-w-0"
          [ngClass]="viewMode === 'list' ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'"
        >
          @for (_ of skeletonCardIndices; track $index) {
            <app-skeleton variant="card" />
          }
        </div>
      } @else {
        <div
          class="dataset-home__grid grid gap-4 min-w-0"
          [ngClass]="viewMode === 'list' ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'"
        >
          @for (card of displayedDatasets; track card.id) {
            <app-dataset-card [card]="card"></app-dataset-card>
          }
        </div>
      }

      @if (!isLoading() && displayedDatasets.length === 0) {
        <p class="dataset-home__empty text-sm m-0 py-6 text-center">
          No datasets match your filters or search. Try adjusting filters or search terms.
        </p>
      }

      @if (!isLoading() && effectiveTotalPages > 1) {
        <nav class="dataset-home__pagination" aria-label="Dataset pages">
          <button
            type="button"
            class="dataset-home__page-btn dataset-home__page-btn--nav"
            [disabled]="currentPage <= 1"
            aria-label="Previous page"
            (click)="onPageChange(currentPage - 1)"
          >
            &lt;
          </button>
          @for (item of paginationItems; track $index) {
            @if (item === 'ellipsis') {
              <span class="dataset-home__ellipsis" aria-hidden="true">…</span>
            } @else {
              <button
                type="button"
                class="dataset-home__page-btn"
                [class.dataset-home__page-btn--active]="item === currentPage"
                [attr.aria-current]="item === currentPage ? 'page' : null"
                (click)="onPageChange(item)"
              >
                {{ item }}
              </button>
            }
          }
          <button
            type="button"
            class="dataset-home__page-btn dataset-home__page-btn--nav"
            [disabled]="currentPage >= effectiveTotalPages"
            aria-label="Next page"
            (click)="onPageChange(currentPage + 1)"
          >
            &gt;
          </button>
        </nav>
      }
    </main>
  </div>
  <app-login-modal [visible]="showLoginModal" (visibleChange)="onLoginModalVisibleChange($event)"></app-login-modal>
</div>
<app-footer></app-footer>

